var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "a-menu",
    {
      attrs: {
        "default-selected-keys": [_vm.activeIndex],
        "default-open-keys": _vm.activeOpenIndex,
        "open-keys": _vm.openKeys,
        "selected-keys": [_vm.activeIndexSelf],
        mode: _vm.MENUCONFIG.STYLE.isTop ? "horizontal" : "inline",
        theme: _vm.MENUCONFIG.STYLE.theme
      },
      on: { click: _vm.handleSelect, openChange: _vm.onOpenChange }
    },
    [
      _vm._l(_vm.menuData, function(item) {
        return [
          !item.subnav
            ? _c(
                "a-menu-item",
                { key: item.menuCode },
                [
                  _c("a-icon", { attrs: { type: "home" } }),
                  _c("span", [_vm._v(_vm._s(item.menuName))])
                ],
                1
              )
            : _c(
                "a-sub-menu",
                { key: item.menuCode },
                [
                  _c(
                    "span",
                    { attrs: { slot: "title" }, slot: "title" },
                    [
                      _c("a-icon", { attrs: { type: _vm.getIcon(item.icon) } }),
                      _vm._v(" "),
                      _vm.messageMap[item.menuCode]
                        ? _c(
                            "a-badge",
                            {
                              attrs: {
                                count: _vm.getMenuMsgCount(
                                  _vm.messageMap[item.menuCode]
                                ),
                                offset: [15, -2]
                              }
                            },
                            [_c("span", [_vm._v(_vm._s(item.menuName))])]
                          )
                        : _c("span", [_vm._v(_vm._s(item.menuName))])
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm._l(item.subnav, function(sub) {
                    return [
                      !sub.subnav
                        ? _c("a-menu-item", { key: sub.menuCode }, [
                            _c(
                              "span",
                              [
                                _c("span", { staticClass: "spont" }),
                                _vm._v(" "),
                                _vm.messageMap[item.menuCode] &&
                                _vm.messageMap[item.menuCode][sub.path]
                                  ? _c(
                                      "a-badge",
                                      {
                                        attrs: {
                                          count:
                                            _vm.$store.getters[
                                              "home/getMessageCount"
                                            ][
                                              _vm.messageMap[item.menuCode][
                                                sub.path
                                              ]
                                            ],
                                          offset: [18, -1]
                                        }
                                      },
                                      [_vm._v(_vm._s(sub.menuName))]
                                    )
                                  : _c("span", [_vm._v(_vm._s(sub.menuName))])
                              ],
                              1
                            )
                          ])
                        : _c(
                            "a-sub-menu",
                            { key: sub.menuCode },
                            [
                              _c(
                                "span",
                                { attrs: { slot: "title" }, slot: "title" },
                                [_c("span", [_vm._v(_vm._s(sub.menuName))])]
                              ),
                              _vm._v(" "),
                              _vm._l(sub.subnav, function(subson) {
                                return _c(
                                  "a-menu-item",
                                  { key: subson.menuCode },
                                  [
                                    _c("span", [
                                      _c("span", { staticClass: "spont" }),
                                      _vm._v(_vm._s(subson.menuName))
                                    ])
                                  ]
                                )
                              })
                            ],
                            2
                          )
                    ]
                  })
                ],
                2
              )
        ]
      })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-81001ae8", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-81001ae8","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components-frame/menu/menu-tree.vue
// module id = iFAm
// module chunks = 1